var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"target-el":"#filter"}},[_c('primary-filter',{attrs:{"noSearchFilter":true}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }